import { gql } from '@apollo/client';

export const MY_NOTIFICATION = gql`
  query myNotifications {
    myNotifications {
      recordId
      title
      description
      priority
      type
      read
      canDelete
      creationDate
      missionRecordId
      societyRecordId
      activityRecordId
      bloomerRecordId
      link
    }
  }
`;

export const ME = gql`
  query me {
    me {
      profile {
        id
        provider
        roles
        displayName
        name {
          familyName
          givenName
        }
        email
      }
      bloomer {
        invitation {
          recordId
          token
          status
        }
        recordId
        fullname
        firstname
        lastname
        email
        slack
        secondaryEmail
        phoneNumber
        communicationType
        accountManager {
          fullname
          recordId
        }
        credentialID
        mission {
          isActive
          recordId
          label
          beginMission
          endMission
          CSM {
            fullname
          }
          clientSociety {
            name
            recordId
          }
          pricing {
            recordId
            purchasePricePerDayWithoutTaxes
            startDate
          }
          hoursPerDays
          bloomerBillingSociety {
            recordId
            name
            status
            siret
            KBIS
            KbisExpirationDate
            IBAN
            BIC
            URSSAFVigilanceCertificate
            URSSAFVCExpirationDate
            RCPVigilanceCertificate
            RCPExpirationDate
            portage
            addressCountryCode
            tva
            billingContacts {
              recordId
              fullname
              firstname
              lastname
              email
              phoneNumber
              nameJob
            }
          }
        }
      }
    }
  }
`;
export const ALL_BLOOMERS = gql`
  query bloomers {
    bloomers {
      fullname
      recordId
      firstname
      lastname
      email
      phoneNumber
      slack
      accountManager {
        recordId
        fullname
      }
    }
  }
`;

// exemple d'usage de fragment grapqhl
const I_MISSIONS_PERIOD = gql`
  fragment IMissionPeriod on IMission {
    beginMission
    endMission
  }
`;

export const ALL_MISSIONS = gql`
  query allMissions($isActive: Boolean, $missionIds: [String]) {
    allMissions(isActive: $isActive, missionIds: $missionIds) {
      count
      results {
        recordId
        label
        bloomerFullName
        ...IMissionPeriod
        clientSocietyName
        bloomerSocietyName
        createdAt
        isActive
        replacement
        type
        hoursPerDays
        jobOwner {
          firstname
          lastname
          email
        }
        pricing {
          recordId
          startDate
          purchasePricePerDayWithoutTaxes
          salePricePerDayWithoutTaxes
          taxes
          astreinteCoef
        }
      }
    }
  }
  ${I_MISSIONS_PERIOD}
`;

export const ALL_MISSIONS_WITH_EXTENSION = gql`
  query allMissions($missionIds: [String]) {
    allMissions(missionIds: $missionIds) {
      count
      results {
        recordId
        label
        beginMission
        bloomerFullName
        endMission
        createdAt
        isActive
        clientSocietyName
        replacement
        hoursPerDays
        extension {
          assessment
          newEndDate
        }
        type
      }
    }
  }
`;

export const GET_ONE_ACTIVITY = gql`
  query activities($recordId: ID, $month: Date, $missionRecordId: String) {
    activities(recordId: $recordId, month: $month, missionRecordId: $missionRecordId) {
      recordId
      mission {
        recordId
        hoursPerDays
        beginMission
        endMission
      }
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      astreinte
      billed
      validated
      signing
      signingDocumentId
      signedCount
      urlCraS3
      urlInvoicesS3
      signingEmbedBloomerId
      payed
      lastSupplierError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      hoursPerDays
    }
  }
`;

export const ACTIVITIES_FOR_ONE_MISSION = gql`
  query missions($recordId: String) {
    missions(recordId: $recordId) {
      recordId
      label
      beginMission
      endMission
      enableCRAUpload
      enableBusinessReferalNpsBloomer
      contactOperations {
        recordId
        email
      }
      bloomerBillingSociety {
        recordId
        URSSAFVigilanceCertificate
        KBIS
        URSSAFVCExpirationDate
        RCPVigilanceCertificate
        RCPExpirationDate
        portage
        status
        addressCountryCode
        tva
      }
      activity {
        recordId
        month
        nbDaysWorked
        nbDaysMarkupWorked
        nbDaysMarkup2Worked
        nbDaysDetails
        astreinte
        billed
        validated
        signing
        signingDocumentId
        signedCount
        urlCraS3
        urlInvoicesS3
        urlAdditionalInvoicesS3
        signingEmbedBloomerId
        payed
        lastSupplierError
        supplierInvoiceStatus
        externalSupplierInvoiceId
        hoursPerDays
        CRAStatus
      }
      clientSocietyName
      hoursPerDays
      bloomerFullName
    }
  }
`;

export const GET_ONE_FULL_MISSION = gql`
  query missions($recordId: String) {
    missions(recordId: $recordId) {
      origin
      hoursPerDays
      recordId
      jobId
      externalId
      isActive
      replacement
      enableCRAUpload
      enableBusinessReferalNpsClient
      enableBusinessReferalNpsBloomer
      shouldBeCountAsDeal
      label
      beginMission
      endMission
      contractType
      clientPaydateDays
      bloomerPaydateDays
      billingContacts {
        fullname
        firstname
        lastname
        email
        phoneNumber
        recordId
        nameJob
      }
      type
      CSM {
        fullname
      }
      jobOwner {
        firstname
        lastname
        email
        role
      }
      pricing {
        recordId
        taxes
        purchasePricePerDayWithoutTaxes
        salePricePerDayWithoutTaxes
        startDate
        astreinteCoef
      }
      bloomer {
        fullname
        recordId
        firstname
        lastname
        email
        secondaryEmail
        phoneNumber
        slack
        credentialID
        hiresweetContactId
        accountManager {
          recordId
          fullname
        }
      }
      contactOperations {
        fullname
        firstname
        lastname
        email
        phoneNumber
        recordId
        nameJob
      }
      clientLegalContacts {
        fullname
        firstname
        lastname
        email
        phoneNumber
        recordId
        nameJob
      }
      bloomerLegalContacts {
        fullname
        firstname
        lastname
        email
        phoneNumber
        recordId
        nameJob
      }
      resolvedClientPdsContact {
        contact {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        source
      }
      resolvedSupplierSstContact {
        contact {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        source
      }
      purchaseOrderRequired
      effectivePurchaseOrderRequired
      purchaseOrders {
        recordId
        orderNumber
        missionsRecordId
        clientSocietyRecordId
        fileUrl
        startDate
        endDate
        amountHT
        invoicedAmountHT
        remainingAmountHT
        useForNonWorkingHours
        invoiceComment
        status
      }
      clientSociety {
        name
        status
        siret
        recordId
        isClient
        orderNumberRequired
        billingContacts {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        legalContacts {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
      }
      clientBillingSociety {
        name
        status
        siret
        recordId
        addressCountryCode
        tva
        isClient
        orderNumberRequired
        billingContacts {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        legalContacts {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
      }
      bloomerBillingSociety {
        name
        status
        siret
        recordId
        portage
        KBIS
        KbisExpirationDate
        IBAN
        BIC
        URSSAFVigilanceCertificate
        URSSAFVCExpirationDate
        RCPVigilanceCertificate
        RCPExpirationDate
        addressCountryCode
        tva
        isClient
        billingContacts {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        legalContacts {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
      }
    }
  }
`;

export const GET_LEGAL_CONTACT_MISSION = gql`
  query legalContactMission($recordId: String) {
    missions(recordId: $recordId) {
      recordId
      resolvedClientPdsContact {
        contact {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        source
      }
      resolvedSupplierSstContact {
        contact {
          fullname
          firstname
          lastname
          email
          phoneNumber
          recordId
          nameJob
        }
        source
      }
    }
  }
`;

export const CHECK_INVITATION_TOKEN = gql`
  query checkInvitationToken($token: String!) {
    checkInvitationToken(token: $token) {
      recordId
      status
      missionRecordId
      emailCaptured
    }
  }
`;

export const GET_NOTIFICATION_CRA_HISTORY = gql`
  query getNotificationCraHistory($id: String, $month: Date, $missionId: String) {
    getNotificationCraHistory(id: $id, month: $month, missionId: $missionId) {
      processedOn
      id
      progress
      error
      data {
        recordId
        contact
        type
        title
      }
    }
  }
`;

export const RECRUITEMENTS = gql`
  query getRecruitements($isTrialPeriod: Boolean) {
    getRecruitements(isTrialPeriod: $isTrialPeriod) {
      customerName
      salesPriceWithoutTaxes
      trialPeriodEndDate
      billingDate
      description
      nextStep
      recordId
      billed
      externalId
      billingContactFullname
      replacement
      paymentTerms
      origin
      cancelled
      lastCustomerInvoiceError
      taxes
      externalCustomerInvoiceId
      externalCustomerInvoiceUrl
      bdc
      businessType
      invoiceStatus
      accountManager {
        firstname
        lastname
        email
        role
        avatarUrl
        phoneNumber
        externalId
      }
      paymentTermsDetails
    }
  }
`;

export const BOOM = gql`
  query boom($code: Int) {
    boom(code: $code)
  }
`;

export const FINANCES = gql`
  query getFinances($beginDate: DateTime, $endDate: DateTime, $isExpense: Boolean) {
    getFinances(beginDate: $beginDate, endDate: $endDate, isExpense: $isExpense) {
      date
      price
      financeType
      year
      isExpense
      isForecast
    }
  }
`;

export const FINANCE_ONE_MONTH = gql`
  query getFinanceByMonth($date: DateTime, $isExpense: Boolean) {
    getFinanceByMonth(date: $date, isExpense: $isExpense) {
      date
      price
      financeType
      year
      isExpense
      isForecast
    }
  }
`;

export const MISSION = gql`
  query missions($activityMonth: DateTime, $isMissingCRA: Boolean, $recordId: String) {
    missions(recordId: $recordId, activityMonth: $activityMonth, isMissingCRA: $isMissingCRA) {
      bloomerFullName
      label
      clientSocietyName
      statusBloomer
      recordId
      bloomerPaydateDays
      beginMission
      endMission
      CSM {
        firstname
      }
      activity {
        bloomerFullname
        signingDocumentId
        month
        CRAStatus
        urlInvoicesS3
        urlAdditionalInvoicesS3
        recordId
        billed
        dateUploadInvoice
        clientMission
        validated
        lastError
        payed
        hoursPerDays
      }
    }
  }
`;

export const GET_MISSION_FOLLOWUP = gql`
  query getMissionFollowUp($month: String, $type: String, $activityId: String) {
    getMissionFollowUp(month: $month, type: $type, activityId: $activityId) {
      recordId
      score
      comment
      fullName
      missionLabel
      enableBusinessReferalNpsClient
    }
  }
`;

export const DASHBOARD_MISSION_DATA = gql`
  query dashboardMissionData($startDate: DateTime, $extended: Boolean) {
    dashboardMissionData(startDate: $startDate, extended: $extended) {
      D {
        currentYear {
          month
          count
          missionIds
        }
        lastYear {
          month
          count
          missionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
      NS {
        currentYear {
          month
          count
          missionIds
        }
        lastYear {
          month
          count
          missionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
      M {
        currentYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        lastYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
      F {
        currentYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        lastYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
      EB {
        currentYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        lastYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
      BE {
        currentYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        lastYear {
          month
          count
          missionIds
          estimatedMissionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
      BR {
        currentYear {
          month
          count
          missionIds
        }
        lastYear {
          month
          count
          missionIds
        }
        diff {
          month
          count
        }
        average {
          currentYear
          lastYear
        }
      }
    }
  }
`;

export const GET_EXTENSION_ASSESSMENT = gql`
  query getExtensionAssessment($missionId: String!) {
    getExtensionAssessment(missionId: $missionId) {
      missionId
      assessment
      newEndDate
      updatedBy
      updatedAt
    }
  }
`;

const fieldForActivity = `{
  missionId
  missionLabel
  bloomerFullName
  clientSocietyName
  contactOperationsName
  activityId
  activityMonth
  status
  craURL
  signedCount
  bloomerSignatureInfo {
    signedAt
    ip
    signerName
  }
  clientSignatureInfo {
    signedAt
    ip
    signerName
  }
  invoiceURL
  additionalInvoiceURL
  signingDocumentId
  bloomerPayDateDays
  dateUploadInvoice
  bloomerInvoiceBilled
  bloomerInvoiceStatus
  bloomerInvoiceLastError
  supplierInvoiceStatus
  externalSupplierInvoiceId
  externalCustomerInvoiceId
  externalCustomerInvoiceMarkupId
  clientInvoicePennylaneUrl
  clientInvoiceMarkupPennylaneUrl
  bloomerInvoicePennylaneUrl
  bloomerSocietyName
  bloomerSocietyPortage
  clientInvoiceStatus
  clientInvoiceLastError
  clientInvoiceBilled
  jobOwner {
    firstname
    lastname
    email
  }
  bloomerScore
  bloomerComment
  bloomerScoreDate
  clientScore
  clientComment
  clientScoreDate
  nbDaysWorked
  nbDaysMarkupWorked
  nbDaysMarkup2Worked
  nbDaysDetails
  nbDaysAstreinteWorked
  hoursPerDays
  salePricePerDayWithoutTaxes
  purchasePricePerDayWithoutTaxes
  astreinteCoef
  daysManuallyModified
}`;

export const GET_CRA_BY_MONTH = gql`
  query getCraByMonth($month: DateTime) {
    getCraByMonth(month: $month) 
    ${fieldForActivity}
  }
`;

export const GET_CRA_BY_MISSION = gql`
  query getCraByMission($missionId: ID!) {
    getCraByMission(missionId: $missionId) 
    ${fieldForActivity}
  }
`;

export const GET_CRA_DAYS_MANUAL_EDIT_HISTORY = gql`
  query craDaysManualEditHistory($craAirtableId: String!) {
    craDaysManualEditHistory(craAirtableId: $craAirtableId) {
      editedAt
      editedBy
      reason
      beforeNormalWorkedDays
      beforeSaturdaysWorkedDays
      beforeSundayAndHolidaysWorkedDays
      beforeAstreinteWorkedDays
      afterNormalWorkedDays
      afterSaturdaysWorkedDays
      afterSundayAndHolidaysWorkedDays
      afterAstreinteWorkedDays
    }
  }
`;

export const GET_LEGAL_CONTRACTS_BY_MISSION = gql`
  query getLegalContractsByMission($missionId: String!, $filter: LegalContractsByMissionFilterInput) {
    getLegalContractsByMission(missionId: $missionId, filter: $filter) {
      mission {
        id
        label
        bloomerId
        bloomerFullName
        clientSocietyId
        clientSocietyName
        bloomerSocietyName
      }
      contracts {
        id
        recordId
        createdAt
        createdDate
        signedDate
        type
        externalDocumentId
        nbSigner
        signedCount
        signerDocId1
        provider
        status
        contractTemplate
        step
        emptyFileUrl
        signedFileUrl
        refusedReason
        signLink
      }
    }
  }
`;

export const GET_LEGAL_CONTRACTS = gql`
  query getLegalContracts($status: MissionStatusFilter!) {
    getLegalContracts(status: $status) {
      mission {
        id
        label
        bloomerId
        bloomerFullName
        clientSocietyId
        clientSocietyName
        bloomerSocietyName
        accountManager {
          firstname
          lastname
        }
      }
      contracts {
        id
        recordId
        createdAt
        createdDate
        signedDate
        type
        externalDocumentId
        nbSigner
        signedCount
        signerDocId1
        provider
        status
        contractTemplate
        step
        emptyFileUrl
        signedFileUrl
        refusedReason
        signLink
      }
    }
  }
`;

export const CRM_VISITOR_TOKEN = gql`
  query getCRMVisitorToken {
    getCRMVisitorToken {
      token
      email
    }
  }
`;

export const GET_BLOOMIE_BY_EMAIL = gql`
  query getBloomieByEmail($email: String!) {
    getBloomieByEmail(email: $email) {
      firstname
      lastname
      email
      role
      avatarUrl
      phoneNumber
      externalId
    }
  }
`;

export const GET_CLIENT_ACTIVITY = gql`
  query getClientActivity($signingDocumentID: String!) {
    getClientActivity(signingDocumentID: $signingDocumentID) {
      recordId
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      astreinte
      billed
      validated
      signing
      signingDocumentId
      signedCount
      urlCraS3
      signingEmbedBloomerId
      signingEmbedClientId
      payed
      lastSupplierError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      hoursPerDays
      CRAStatus
      mission {
        recordId
        contactOperations {
          recordId
          email
        }
        clientSocietyName
        bloomerFullName
        label
      }
    }
  }
`;

export const PURCHASE_ORDERS = gql`
  query purchaseOrders($filters: PurchaseOrdersFilterInput) {
    purchaseOrders(filters: $filters) {
      recordId
      orderNumber
      missionsRecordId
      clientSocietyRecordId
      fileUrl
      startDate
      endDate
      amountHT
      invoicedAmountHT
      remainingAmountHT
      useForNonWorkingHours
      invoiceComment
      status
    }
  }
`;

export const PURCHASE_ORDER = gql`
  query purchaseOrder($id: ID!) {
    purchaseOrder(id: $id) {
      recordId
      orderNumber
      missionsRecordId
      clientSocietyRecordId
      fileUrl
      startDate
      endDate
      amountHT
      invoicedAmountHT
      remainingAmountHT
      useForNonWorkingHours
      invoiceComment
      status
    }
  }
`;

export const PURCHASE_ORDER_DASHBOARD_KPIS = gql`
  query purchaseOrderDashboardKpis($referenceDate: Date) {
    purchaseOrderDashboardKpis(referenceDate: $referenceDate) {
      referenceDate
      atDate {
        received {
          count
          missionRecordIds
        }
        waiting {
          count
          missionRecordIds
        }
        missing {
          count
          missionRecordIds
        }
      }
      monthPlus1 {
        received {
          count
          missionRecordIds
        }
        waiting {
          count
          missionRecordIds
        }
        missing {
          count
          missionRecordIds
        }
      }
      monthPlus2 {
        received {
          count
          missionRecordIds
        }
        waiting {
          count
          missionRecordIds
        }
        missing {
          count
          missionRecordIds
        }
      }
      monthPlus3 {
        received {
          count
          missionRecordIds
        }
        waiting {
          count
          missionRecordIds
        }
        missing {
          count
          missionRecordIds
        }
      }
      tierCounts {
        expired {
          count
          missionRecordIds
        }
        monthPlus1Missing {
          count
          missionRecordIds
        }
        monthPlus2Missing {
          count
          missionRecordIds
        }
      }
    }
  }
`;

export const ALL_SOCIETYS = gql`
  query allSocietys($where: SocietyGQLQueryInput) {
    allSocietys(where: $where) {
      recordId
      name
      isClient
      siret
    }
  }
`;

export const GET_MISSIONS_BY_SEARCH = gql`
  query getMissionsBySearch($reasearchField: String!) {
    getMission(reasearchField: $reasearchField) {
      recordId
      label
      bloomerFullName
      clientSocietyName
      clientSociety {
        recordId
      }
      clientBillingSociety {
        recordId
      }
    }
  }
`;

export const PURCHASE_ORDER_MISSION_COVERAGES = gql`
  query purchaseOrderMissionCoverages($referenceDate: Date) {
    purchaseOrderMissionCoverages(referenceDate: $referenceDate) {
      missionRecordId
      missionLabel
      clientSocietyName
      tier
      hasReceivedPurchaseOrder
      coversCurrentMonth
      coversMonthPlus1
      coversMonthPlus2
      coversMonthPlus3
    }
  }
`;

// Requête dédiée au dashboard BDC : enrichit les missions manquantes avec le TJM,
// le bloomer et le jobOwner (AM). Document distinct du ALL_MISSIONS général pour ne
// pas alourdir ce dernier (impact perf) — cf. spec TEC-2890.
export const MISSIONS_PURCHASE_ORDER_ENRICHMENT = gql`
  query allMissionsForPurchaseOrderDashboard($missionIds: [String]) {
    allMissions(missionIds: $missionIds) {
      count
      results {
        recordId
        label
        beginMission
        endMission
        clientSocietyName
        bloomerFullName
        hoursPerDays
        pricing {
          recordId
          startDate
          salePricePerDayWithoutTaxes
        }
        jobOwner {
          firstname
          lastname
        }
      }
    }
  }
`;

export const GET_MISSION_PRICINGS = gql`
  query missionPricings($missionRecordId: ID!) {
    missionPricings(missionRecordId: $missionRecordId) {
      recordId
      startDate
      salePricePerDayWithoutTaxes
      purchasePricePerDayWithoutTaxes
      astreinteCoef
    }
  }
`;

// --- TEC-3052 : recherche annuaire + tableau de bord de mission V2 (TEC-3051) ---

export const SEARCH_CONTACTS = gql`
  query searchContacts($query: String!) {
    searchContacts(query: $query) {
      recordId
      fullname
      firstname
      lastname
      email
      phoneNumber
      nameJob
      isBilling
      isOperational
      communicationType
    }
  }
`;

export const SEARCH_SOCIETY = gql`
  query searchSociety($query: String!, $isClient: Boolean) {
    searchSociety(query: $query, isClient: $isClient) {
      recordId
      name
      siret
      status
      isClient
    }
  }
`;

export const GET_SOCIETY_MISSIONS = gql`
  query society($id: ID!) {
    society(id: $id) {
      recordId
      name
      mission {
        recordId
        label
        isActive
      }
    }
  }
`;

const CONTACT_DASHBOARD_FIELDS = gql`
  fragment ContactDashboardFields on Contact {
    recordId
    fullname
    firstname
    lastname
    email
    phoneNumber
    nameJob
    isBilling
    isOperational
    communicationType
  }
`;

/**
 * Tableau de bord de mission V2 (TEC-3051) — chargement asynchrone par section.
 *
 * Plutôt qu'une seule grosse requête, le front tire ces requêtes en parallèle (même root
 * `missions(recordId)`) et affiche chaque bloc dès sa réponse. Elles sont additives et
 * reposent sur les field resolvers paresseux existants — aucun dev backend.
 * CRA / facturation / NPS / satisfaction : voir `GET_CRA_BY_MISSION`.
 */

export const MISSION_HEADER = gql`
  query missionHeader($recordId: String) {
    missions(recordId: $recordId) {
      recordId
      externalId
      jobId
      origin
      label
      type
      isActive
      beginMission
      endMission
      contractType
      hoursPerDays
      clientPaydateDays
      bloomerPaydateDays
      replacement
      shouldBeCountAsDeal
      enableCRAUpload
      enableBusinessReferalNpsClient
      enableBusinessReferalNpsBloomer
      CSM {
        fullname
      }
      jobOwner {
        firstname
        lastname
        email
        role
      }
      bloomer {
        recordId
        fullname
        firstname
        lastname
        email
        secondaryEmail
        phoneNumber
        slack
        credentialID
        accountManager {
          recordId
          fullname
        }
      }
      extension {
        assessment
        newEndDate
      }
    }
  }
`;

export const MISSION_PRICING = gql`
  query missionPricing($recordId: String) {
    missions(recordId: $recordId) {
      recordId
      pricing {
        recordId
        startDate
        taxes
        purchasePricePerDayWithoutTaxes
        salePricePerDayWithoutTaxes
        astreinteCoef
      }
    }
  }
`;

export const MISSION_CONTACTS = gql`
  query missionContacts($recordId: String) {
    missions(recordId: $recordId) {
      recordId
      contactOperations {
        ...ContactDashboardFields
      }
      clientLegalContacts {
        ...ContactDashboardFields
      }
      bloomerLegalContacts {
        ...ContactDashboardFields
      }
      billingContacts {
        ...ContactDashboardFields
      }
      resolvedClientPdsContact {
        contact {
          ...ContactDashboardFields
        }
        source
      }
      resolvedClientBillingContacts {
        contact {
          ...ContactDashboardFields
        }
        source
      }
      resolvedSupplierSstContact {
        contact {
          ...ContactDashboardFields
        }
        source
      }
    }
  }
  ${CONTACT_DASHBOARD_FIELDS}
`;

export const MISSION_SOCIETIES = gql`
  query missionSocieties($recordId: String) {
    missions(recordId: $recordId) {
      recordId
      clientSociety {
        recordId
        name
        status
        siret
        isClient
        orderNumberRequired
        autoValidateInvoice
        paydateDays
        tva
        addressName
        addressPart1
        addressZip
        addressTown
        addressCountryCode
        billingContacts {
          ...ContactDashboardFields
        }
        legalContacts {
          ...ContactDashboardFields
        }
        contacts {
          ...ContactDashboardFields
        }
      }
      clientBillingSociety {
        recordId
        name
        status
        siret
        isClient
        orderNumberRequired
        autoValidateInvoice
        paydateDays
        tva
        addressName
        addressPart1
        addressZip
        addressTown
        addressCountryCode
        billingContacts {
          ...ContactDashboardFields
        }
        legalContacts {
          ...ContactDashboardFields
        }
      }
      bloomerBillingSociety {
        recordId
        name
        status
        siret
        isClient
        portage
        KBIS
        KbisExpirationDate
        IBAN
        BIC
        URSSAFVigilanceCertificate
        URSSAFVCExpirationDate
        RCPVigilanceCertificate
        RCPExpirationDate
        addressCountryCode
        tva
        billingContacts {
          ...ContactDashboardFields
        }
        legalContacts {
          ...ContactDashboardFields
        }
      }
    }
  }
  ${CONTACT_DASHBOARD_FIELDS}
`;

export const MISSION_PURCHASE_ORDERS = gql`
  query missionPurchaseOrders($recordId: String) {
    missions(recordId: $recordId) {
      recordId
      purchaseOrderRequired
      effectivePurchaseOrderRequired
      purchaseOrders {
        recordId
        orderNumber
        missionsRecordId
        clientSocietyRecordId
        fileUrl
        startDate
        endDate
        amountHT
        invoicedAmountHT
        remainingAmountHT
        useForNonWorkingHours
        invoiceComment
        status
      }
    }
  }
`;

export const GET_PUBLIC_CLIENT_ACTIVITY = gql`
  query getPublicClientActivity($signingDocumentID: String!) {
    getPublicClientActivity(signingDocumentID: $signingDocumentID) {
      recordId
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      astreinte
      billed
      validated
      signing
      signingDocumentId
      signedCount
      urlCraS3
      signingEmbedBloomerId
      signingEmbedClientId
      payed
      lastSupplierError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      hoursPerDays
      CRAStatus
      mission {
        recordId
        contactOperations {
          recordId
          email
        }
        clientSocietyName
        bloomerFullName
        label
      }
    }
  }
`;
